import { isValidPhoneNumber, type CountryCode } from 'libphonenumber-js/min';

const WORD = String.raw`\p{L}[\p{L}.'-]*`;
const NAME_FORMAT = new RegExp(String.raw`^${WORD}(\s+${WORD})+$`, 'u');

export function isValidPhone(value: string, country?: CountryCode): boolean {
  return isValidPhoneNumber(value, country);
}

export function isValidName(value: string): boolean {
  return NAME_FORMAT.test(value.normalize('NFC').trim());
}
